module.exports = __webpack_public_path__ + "img/logo_pyeongan.da902db.png";